module.exports = __webpack_public_path__ + "static/media/arrow.a34c4092.svg";